import React, { memo, useMemo } from "react";
import { withNamespaces } from "react-i18next";
import { Col, Row } from "reactstrap";
import Widget from "src/modules/data-protection/pages/admin/dashboard/components/Widget";
import complianceScoreIcon from "src/modules/data-protection/assets/icons/ai_governance_compliance_score.svg";
import highRiskAiSystemsIcon from "src/modules/data-protection/assets/icons/ai_governance_high_risk_ai_systems.svg";
import highRiskProvidersIcon from "src/modules/data-protection/assets/icons/ai_governance_high_risk_providers.svg";
import ceReadyIcon from "src/modules/data-protection/assets/icons/ai_governance_ce_ready.svg";
import gapsOpenIcon from "src/modules/data-protection/assets/icons/ai_governance_gaps_open.svg";
import prohibitedAiSystemsIcon from "src/modules/data-protection/assets/icons/ai_governance_prohibited_ai_systems.svg";
import totalAiAssetsIcon from "src/modules/data-protection/assets/icons/ai_governance_total_ai_assets.svg";
import unacceptableRiskIcon from "src/modules/data-protection/assets/icons/ai_governance_unacceptable_risk.svg";

const readMetric = (value) => {
    if (value != null && typeof value === "object") {
        return {
            amount: Number(value.amount) || 0,
            percent: Number(value.percent) || 0,
        };
    }

    return {
        amount: Number(value) || 0,
        percent: 0,
    };
};

const RiskOverviewCards = memo(({ t, data = {}, isFetching }) => {
    const widgetsList = useMemo(() => {
        const totalAiAssets = readMetric(data?.totalAiAssets);
        const prohibitedAiSystems = readMetric(data?.prohibitedAiSystems);
        const highRiskAiSystems = readMetric(data?.highRiskAiSystems);
        const complianceScore = readMetric(data?.complianceScore);
        const unacceptableRisk = readMetric(data?.unacceptableRisk);
        const highRiskProviders = readMetric(data?.highRiskProviders);
        const ceReadyCount = readMetric(data?.ceReadyCount);
        const gapsOpenCount = readMetric(data?.gapsOpenCount);

        return [
            {
                title: "Total AI Assets",
                amount: totalAiAssets.amount,
                icon: totalAiAssetsIcon,
            },
            {
                title: "Prohibited AI Systems",
                amount: prohibitedAiSystems.amount,
                icon: prohibitedAiSystemsIcon,
                chart: {
                    show: true,
                    percent: prohibitedAiSystems.percent,
                },
            },
            {
                title: "High-Risk AI Systems",
                amount: highRiskAiSystems.amount,
                icon: highRiskAiSystemsIcon,
                chart: {
                    show: true,
                    percent: highRiskAiSystems.percent,
                },
            },
            {
                title: "Compliance Score",
                amount: `${complianceScore.amount}`,
                icon: complianceScoreIcon,
                chart: {
                    show: true,
                    percent: complianceScore.percent,
                },
            },
            {
                title: "Unacceptable Risk",
                amount: unacceptableRisk.amount,
                icon: unacceptableRiskIcon,
                chart: {
                    show: true,
                    percent: unacceptableRisk.percent,
                },
            },
            {
                title: "High-Risk Providers",
                amount: highRiskProviders.amount,
                icon: highRiskProvidersIcon,
                chart: {
                    show: true,
                    percent: highRiskProviders.percent,
                },
            },
            {
                title: "CE Ready",
                amount: ceReadyCount.amount,
                icon: ceReadyIcon,
                chart: {
                    show: true,
                    percent: ceReadyCount.percent,
                },
            },
            {
                title: "Gaps Open",
                amount: gapsOpenCount.amount,
                icon: gapsOpenIcon,
                chart: {
                    show: true,
                    percent: gapsOpenCount.percent,
                },
            },
        ];
    }, [data]);

    if (isFetching) {
        return (
            <Row className="mb-3 row-cols-1 row-cols-md-2 row-cols-lg-4">
                {[1, 2, 3, 4, 5, 6, 7, 8].map((item) => (
                    <Col className="mb-3" key={item}>
                        <div
                            className="dt-field dt-skeleton"
                            style={{ width: "100%", height: "120px" }}
                        />
                    </Col>
                ))}
            </Row>
        );
    }

    return (
        <Row className="mb-3 row-cols-1 row-cols-md-2 row-cols-lg-4">
            {widgetsList.map((widgetData) => (
                <Col className="mb-3" key={widgetData.title}>
                    <Widget {...widgetData} />
                </Col>
            ))}
        </Row>
    );
});

export default withNamespaces()(RiskOverviewCards);
